import React, { useEffect, useState, useContext } from 'react';
// import { useHistory } from 'react-router-dom'
import projectionsService from '../../services/projectionsService';
import ProjectionsPage from '../../pages/MaestrosPage/ProjectionsPage/ProjectionsPage';
import { Context } from '../../context/Contex';

const Projections = () => {
  const [industries, setIndustries] = useState([]);
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState({
    loIndustri: false,
    loreleases: false,
  });
  const { permisos } = useContext(Context);

  // const history = useHistory()
  const dataIndustries = [];
  const dataRelease = [];

  /*= =======================================================================
  Get Industries
====================================================== ================== */

  const getIndustries = () => {
    projectionsService.getIndustries()
      .then((response) => {
        setIndustries(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        // history.push('/home')
        setLoading(false);
      });
  };

  /*= =======================================================================
  Get Releases
====================================================== ================== */
  const getReleases = () => {
    projectionsService.getReleases()
      .then((response) => {
        setReleases(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        // history.push('/home')
        console.log(error);
      });
  };

  useEffect(() => {
    setLoading({
      loIndustri: true,
      loreleases: true,
    });
    getIndustries();
    getReleases();
  }, []);

  /*= =======================================================================
  Handle handleUpdateIndustries
====================================================== ================== */
  const handleUpdateIndustries = (params) => {
    setLoading({ loIndustri: true });
    projectionsService.putIndistries(params)
      .then(() => {
        getIndustries();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
  Handle handleUpdateIndustries
====================================================== ================== */
  const handleUpdateRelease = (params) => {
    setLoading({ loreleases: true });
    projectionsService.putReleases(params)
      .then(() => {
        getReleases();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (industries) {
    try {
      industries.forEach((value) => {
        dataIndustries.push({
          mes: value.MM,
          año: value.YYYY,
          empresa: value.EMPRESA,
          valor: value.VALOR,
        });
      });
    } catch (err) {
      console.log(err);
    }
  }

  if (releases) {
    try {
      releases.forEach((value) => {
        dataRelease.push({
          mes: value.MES,
          año: value.YYYY,
          linea: value.LINEA,
          meta: value.META_MENSUAL,
        });
      });
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <ProjectionsPage
        industries={dataIndustries}
        releases={dataRelease}
        permisos={permisos}
        onUpdateIndustrie={handleUpdateIndustries}
        onUpdateRelease={handleUpdateRelease}
        loading={loading}
      />
    </>
  );
};

export default Projections;
